<!--异店-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <!-- 顾问不能看这个tab -->
            <div v-if="postId != '2' && postId != 42 && postId != '1472787652026765441'" class="title-tab-box">
                <van-tabs animated v-model="activeName" @change="clickTypeTab">
                    <van-tab title="看门店" name="store"> </van-tab>
                    <van-tab title="看我的" name="mine"> </van-tab>
                </van-tabs>
            </div>
            <div class="select-box flex-y-center flex-between" v-if="postId != '2' && postId != 42 && postId != '1472787652026765441'">
                <div v-if="checkTypeTab == 1" class="select-item mr-30 flex-between flex-y-center" @click="selectEmployeePopup">
                    <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
            <div class="head-chart">
                <div ref="headchart" id="headchart"></div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
            <div class="table-tab-box">
                <div class="table-tab  flex flex-x-center flex-between">
                    <!-- <div v-for="item,index in tableTabList" :key="index"
                        :class="`tab-item ${tabIndex == index+2?'tab-item-active':''}`" @click="clickTab(index+2)">
                        {{item+'1'}}
                    </div> -->
                    <van-tabs v-model="active" class="table-tab" @click="clickTab">
                        <van-tab :title="item" v-for="item, index in tableTabList" :key="index"></van-tab>
                    </van-tabs>
                </div>
                <div class="box-line"></div>
            </div>

            <div class="table-list">
                <div class="table-header flex-y-center flex-between">
                    <div class="header-title flex-1" v-for="item, index in tableTitleList" :key="index">{{ item.title }}</div>
                </div>
                <div class="data-list-box" v-if="tableDataList.length > 0">
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getTableList()" :offset="20" :immediate-check="false">
                        <div :class="` data-list line flex-y-center  ${index + 1 != tableDataList.length ? 'tr-bottom' : ''}`" v-for="(item, index) in tableDataList" :key="index">
                            <div class="header-title Blacks flex-col flex-y-center">
                                <div class="td-item">{{ item.custName }}</div>
                                <div>{{ item.mobile }}</div>
                            </div>
                            <div class=" header-title header-title-ml70 flex-1 Blacks">
                                <div class="td-item" v-if="tabIndex == 4">{{ item.cardConsultantName }}</div>
                                <div class="td-item" v-else-if="tabIndex == 5">{{ item.newCardConsultantName }}</div>
                                <div v-else>{{ item.cardConsultantName }}</div>
                            </div>
                            <div class="header-title header-title-ml35 flex-1 Blacks flex-col flex-y-center">
                                <div class="td-item" v-if="tabIndex == 4">{{ item.newCardConsultantName }}</div>
                                <div class="td-item" v-else-if="tabIndex == 5">{{ item.cardConsultantName }}</div>
                                <div>{{ item.storeName }}</div>
                            </div>
                            <div class="header-title  header-title-ml35 flex-1 Blacks">
                                <div v-if="tabIndex == 4 || tabIndex == 5">{{ item.transferTime }}</div>
                                <div v-else>{{ item.orderTime }}</div>
                            </div>
                        </div>
                    </van-list>

                </div>
                <div class="data-list" v-else style="margin:80px auto">
                    <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" description="暂无数据" />
                </div>
            </div>
        </van-pull-refresh>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
        <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
            <picker title="全部员工" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { timestampToYestoday, getYear } from '@/utils/validate';
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "otherStore",
        inject: ['reload'],
        components: {
            Picker
        },
        data() {
            return {
                pieDataList: [],
                tableDataList: [],
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                dimension: 0, //区分生美医美 1 生美 2 医美
                searchStr: '',
                activeName: "store", //tab
                tabIndex: 2, // table栏下标
                checkedEmployee: null,//所选员工
                showEmployeePopup: false,// 选择员工弹窗
                employeeList: [],// 员工列表
                checkTypeTab: 1,
                page: 1,
                total: 0,
                loading: false,
                finished: false,
                refreshing: false,
                tableTabList: [
                    '本店到异店', '异店到本店', '本店转会异店', '异店转会本店'
                ],
                active: '2'
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            tableTitleList() { // 表头字段
                if (this.tabIndex == 2) {
                    return [
                        {
                            title: '姓名&手机',
                        },
                        {
                            title: '所属顾问',
                        },
                        {
                            title: '最近消费异店',
                        },
                        {
                            title: '异店消费时间',
                        }
                    ]
                } else if (this.tabIndex == 3) {
                    return [
                        {
                            title: '姓名&手机',
                        },
                        {
                            title: '所属顾问',
                        },
                        {
                            title: '所属门店',
                        },
                        {
                            title: '本店消费时间',
                        }
                    ]
                } else if (this.tabIndex == 4) {
                    return [
                        {
                            title: '姓名&手机',
                        },
                        {
                            title: '原所属顾问',
                        },
                        {
                            title: '新专属信息',
                        },
                        {
                            title: '转会时间',
                        }
                    ]
                } else if (this.tabIndex == 5) {
                    return [
                        {
                            title: '姓名&手机',
                        },
                        {
                            title: '新所属顾问',
                        },
                        {
                            title: '原专属信息',
                        },
                        {
                            title: '转会时间',
                        }
                    ]
                }
            }
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.active = this.$route.query.type - 2;
            this.tabIndex = this.$route.query.type;

            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        this.$router.replace({
                            name: "otherStoreRegionPage",
                            query: {
                                type: this.$route.query.type
                            }
                        });
                    }
                }
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getEmpList()
                this.onLoad()
                this.getTableList()
            },
            //资产饼图加载
            onLoad() {
                const _this = this
                this.getDetail().then(() => {
                    let data = [
                        { value: this.pieDataList.storeConsumptionOut, name: '{c|本店到异店 \n' + this.pieDataList.storeConsumptionOut + '人}', itemStyle: { color: '#F9B59F' } },
                        { value: this.pieDataList.storeConsumptionIn, name: '{c|异店到本店 \n' + this.pieDataList.storeConsumptionIn + '人}', itemStyle: { color: '#5678FF' } },
                        { value: this.pieDataList.transferFromOut, name: '{c|本店转会异店 \n' + this.pieDataList.transferFromOut + '人}', itemStyle: { color: '#a8bdfe' } },
                        { value: this.pieDataList.transferFromIn, name: '{c|异店转会本店 \n' + this.pieDataList.transferFromIn + '人}', itemStyle: { color: '#F56C40' } },
                    ]
                    let radius = ['33%', '56%']

                    // 基于准备好的dom，初始化echarts实例
                    let myEcharts = this.$echarts.init(this.$refs.headchart);
                    window.onresize = myEcharts.resize;
                    let options = {
                        series: [
                            {
                                type: 'pie',
                                radius: radius,
                                // avoidLabelOverlap: false,  //备注隐藏
                                label: {
                                    show: true,
                                    // color: "#35434C",
                                    rich: {
                                        c: {
                                            padding: [6, 0, 0, 0],
                                            fontSize: window.innerWidth * 26 / 750,
                                            color: "#35434C",
                                            align: 'left',
                                        },
                                    },
                                },
                                labelLine:
                                {
                                    normal: {
                                        length: 25,
                                        length2: 20,
                                        lineStyle: {
                                            width: 2//设置线条粗细
                                        }
                                    }
                                },
                                data: data
                            }
                        ]
                    };
                    myEcharts.on('click', function (param) { //添加点击事件
                        _this.tabIndex = param.dataIndex + 2
                        _this.active = param.dataIndex
                        _this.page = 1
                        _this.getTableList()
                    });
                    myEcharts.setOption(options);
                });

            },
            // 获取员工列表
            getEmpList() {
                return request({
                    url: "/workEmployee/getEmployeeList",
                    method: "get",
                })
                    .then((res) => {
                        this.employeeList = res.data
                        this.checkedEmployee = this.employeeList[0] //默认全部

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onEmployeeChange(data) {
                this.checkedEmployee = data
                this.showEmployeePopup = false
                this.onRefresh()
            },
            // 弹窗
            selectEmployeePopup() {
                this.showEmployeePopup = true
            },
            // 饼图数据
            getDetail() {
                let params = {
                    empNo: this.checkedEmployee.id,
                    headType: this.checkTypeTab,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: '/messages/pieChartStatistics',
                    method: "get",
                    params: params
                }).then((res) => {
                    this.pieDataList = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 表格数据
            getTableList() {
                let params = {
                    empNo: this.checkedEmployee.id,
                    keysword: this.searchStr,
                    limit: 10,
                    page: this.page,
                    type: this.tabIndex,
                    headType: this.checkTypeTab
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: '/messages/pageDifferentStores',
                    method: "get",
                    params: params
                }).then((res) => {
                    this.tableDataList = this.page == 1 ? res.data.list : this.tableDataList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                    console.log(this.tableDataList);
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.finished = false;
                    if (this.tableDataList.length >= this.total) {
                        this.finished = true;
                    }
                });
            },
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.tableDataList = [];
                this.refreshing = false;
                this.onLoad()
                this.getTableList()
            },

            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "otherStoreRegionPage",
                            query: {
                                type: this.$route.query.type
                            }
                        });
                    } else {
                        this.reload();
                    }
                })
            },
            // 搜索
            onSearch(e) {
                this.searchStr = e
                this.onRefresh();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh();
            },
            //查看类型切换
            clickTypeTab() {
                if (this.activeName == "store") {
                    this.checkTypeTab = 1;
                }
                else {
                    this.checkTypeTab = 2;
                }
                this.onRefresh();
            },
            // table切换
            clickTab(e) {
                this.page = 1
                this.tabIndex = e + 2
                this.getTableList()
            },
        },
    };
</script>

<style scoped lang="less">
    .storageassets-module {
        padding-top: 30px;
    }

    .store-box {
        padding: 0 30px 30px 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .select-box {
        margin: 20px 30px;
        margin-bottom: 0;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .storageassets-module {
        height: 100%;
        overflow-y: auto;
        padding-bottom: 30px;
    }

    .head-chart {
        height: 570px;
    }

    #headchart {
        height: 570px;
    }

    .table-tab-box {
        padding: 0 27px;

        .table-tab {
            width: 100%;
            height: 55px;

            display: flex;
            color: #a0acb5 !important;

            :deep(.van-tab) {
                font-size: 24px !important;
                width: 260px;
                height: 42px;
                line-height: 42px;
                color: #a0acb5;
            }

            :deep(.van-tab--active) {
                color: #35434c;
            }

            :deep(.van-tabs--line .van-tabs__wrap) {
                height: 55px;
            }

            :deep(.van-tabs__line) {
                background-color: #37dbe0;
                height: 4px;
            }
        }

        .box-line {
            width: 690px;
            height: 1px;
            background: #d7d7d7;
            margin: 0 0 30px 0;
            opacity: 0.5;
        }
    }

    .table-list {
        padding: 0 30px 0 30px;

        .tr {
            display: flex;
            width: 100%;
            justify-content: center;
            height: 60px;
            align-items: center;
        }

        .tr-bottom {
            border-bottom: 1px solid #d7d7d7;
        }

        .th {
            width: 40%;
            justify-content: center;
            background: #fafafe;
            color: #66757f;
            display: flex;
            height: 80px;
            align-items: center;
            font-size: 26px;
        }

        .td {
            width: 40%;
            justify-content: center;
            text-align: center;
            font-size: 26px;
            color: #35434c;
        }

        .td-item {
            margin-bottom: 17px;
        }

        .line {
            height: 100px;
            font-size: 28px;
            color: #35434c;
            padding: 0 20px 0 20px;
        }

        .fc {
            color: red;
        }

        .table-header {
            height: 80px;
            background: #fafafe;
            border-radius: 4px;
            padding: 0 22px 0 18px;
            color: #66757f;
        }

        .td-item {
            margin-bottom: 6px;
        }

        .header-title {
            min-width: 75px;
            font-size: 26px;
            text-align: center;
        }

        .header-title:nth-child(3) {
            margin-right: 12px;
        }

        .data-list {
            background: #fff;
            // border-radius: 4px;
            padding: 0 20px 0 20px;
            min-height: 145px;
        }

        .total-td-title-ml {
            margin-left: 40px;
        }
    }

    .total {
        height: 100px;
        background: #f2f2f5;
        border-radius: 8px;
    }

    .total-tr {
        padding: 0 20px 0 20px;
    }

    .total-td {
        min-width: 60px;
        color: #35434c;
        font-weight: 700;
        font-size: 28px;
        text-align: center;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .title-tab-box {
        :deep(.van-tabs__line) {
            display: none;
        }

        :deep(.van-tabs__wrap) {
            display: flex;
            justify-content: center;
        }

        :deep(.van-tab) {
            flex: none !important;
            // flex: 0 0 35% !important;
            width: 250px !important;
            padding: 0 !important;
            height: 70px !important;
            line-height: 70px !important;
            color: #35434c;
            font-size: 30px;
            margin: 0 30px;
        }

        :deep(.van-tab.van-tab--active) {
            height: 70px !important;
            line-height: 70px;
            background: #2fd0d5 !important;
            border-radius: 35px !important;
            color: #fff !important;
            font-weight: normal;
            box-shadow: 4px 10px 30px 0px rgba(55, 219, 224, 0.2);
        }
    }

    :deep(.search .van-search) {
        background-color: #fff !important;
        padding: 5px 30px 30px 30px !important;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 8px 20px 0 20px !important;
        margin-right: 0 !important;
    }
</style>
